import { render, staticRenderFns } from "./VisitTimesTable.vue?vue&type=template&id=b64a9844&scoped=true"
import script from "./VisitTimesTable.vue?vue&type=script&lang=js"
export * from "./VisitTimesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64a9844",
  null
  
)

export default component.exports